import React from 'react';

import { UIFormClient } from '../../../../../external/UIFormClient/domain/abstract/UIFormClient';
import { ReactComponent } from '../../../../../shared/abstract/infrastructrue/ReactComponent';
import { UserCreationFormTemplate } from '../../../domain/forms/templates/UserCreationFormTemplate';
import {
  IUserFormCreator,
  TUserCreationFormComponent,
} from '../../../domain/interfaces';
import { UserDomainSchemas } from '../../../index';
import { UserCreationForm } from './UserCreationForm';
import {
  TUserCreationFormView,
  UserCreationFormView,
} from './UserCreationForm.view';

export class UserCreationFormComponent extends ReactComponent {
  public readonly validationSchema = UserDomainSchemas.userCreationSchema;

  public properties: UIFormClient<IUserFormCreator>['properties'];

  constructor(
    private readonly userCreationFormTemplate: UserCreationFormTemplate,
  ) {
    super();
    this.properties = userCreationFormTemplate.compose().properties;
  }

  public static readonly create = ({
    userCreationFormTemplate,
    userPrincipal,
  }: TUserCreationFormComponent): React.ReactElement<TUserCreationFormView> => {
    return ReactComponent.withAnyOfPermissionsHOC<TUserCreationFormView>(
      ['system-admin:create:users', 'SAVE_USER_ROLES'],
      UserCreationFormView,
      {
        user: userPrincipal,
        UserFormCreator: UserCreationForm.compose(userCreationFormTemplate),
      },
    );
  };
}
